import { Injectable } from "@angular/core";
import {
	HttpEvent,
	HttpInterceptor,
	HttpHandler,
	HttpRequest,
	HttpResponse,
} from "@angular/common/http";

import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

import { AuthService } from "core/auth";
import { Router } from "@angular/router";

@Injectable()
export class InterceptService implements HttpInterceptor {
	constructor(private router: Router, private auth: AuthService) {}

	// intercept request and add token
	intercept(
		request: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		let authToken = this.auth.getAuthToken();
		if (authToken) {
			request = request.clone({
				setHeaders: {
					Authorization: `Bearer ` + authToken,
				},
			});
		}

		return next.handle(request).pipe(
			tap(
				(event) => {
					if (event instanceof HttpResponse) {
						// console.log('all looks good');
						// http response status code
						// console.log(event.status);
					}
				},
				(error) => {
					if (error.status == 401) {
						this.auth.logout();
						this.router.navigateByUrl("/auth");
					}
				}
			)
		);
	}
}
